import { Box, HStack, Text } from '@chakra-ui/react'
import { useThemeColors } from '@/hooks/useThemeColors'

type Props = {
  label: string
  value?: React.ReactNode
  children?: React.ReactNode
  valueAlign?: 'left' | 'right'
}

export default function PropertyRow({ label, value, children, valueAlign = 'right' }: Props) {
  const colors = useThemeColors()
  const display = children ?? value ?? '—'

  return (
    <HStack align="flex-start" justify="space-between" spacing={3} py={1}>
      <Text fontSize="xs" color={colors.textSecondary} flexShrink={0}>
        {label}
      </Text>
      <Box minW={0} flex="1" textAlign={valueAlign}>
        {typeof display === 'string' || typeof display === 'number' ? (
          <Text fontSize="xs" color={colors.text} noOfLines={2}>
            {display || '—'}
          </Text>
        ) : (
          display
        )}
      </Box>
    </HStack>
  )
}
